import { render } from "./HiddenMessages.vue?vue&type=template&id=04339608"
import script from "./HiddenMessages.vue?vue&type=script&lang=js"
export * from "./HiddenMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__